import { t } from 'i18next';
import React from 'react';
import { AznIcon } from '../../components/svgs/arrows';
const Index = ({ color, amount, text, refundAmount }) => {
    return (
        <div className="col">
            <div className={`card radius-10 ${color} bg-gradient`}>
                <div className="card-body custom-total-amaunt">
                    <div className="d-flex align-items-center">
                        <div className='container-amounts'>
                            <p className="mb-0 text-white">{text}</p>
                            <div className='home-amounts'>
                                <h4 className="my-1 text-white amount-w">{amount}</h4>
                                <p className="mb-0 text-white">{t("home.earned")}</p>
                            </div>
                            <div className='home-amounts'>
                                <h6 className="text-white amount-w">{refundAmount}</h6>
                                <p className="mb-0 text-white">{t("home.returned")}</p>
                            </div>
                        </div>
                        <div className="text-white ms-auto font-35">
                            {/* <i className='bx bx-dollar'></i> */}
                            <AznIcon />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(Index);
